export default {
  getConfig: state => {
    return {
      id: state.id,
      name: state.name,
      description: state.description,
      isTempWidgets: state.isTempWidgets,
      isInitialized: state.isInitialized,
      isFiltersEditable: state.isFiltersEditable,
      isLayersEditable: state.isLayersEditable,
      isConfigsEditable: state.isConfigsEditable,
      isPublicView: state.isPublicView,
    };
  },
  isInitialized: state => {
    return state.isInitialized;
  },
  isFiltersVisible: state => {
    return state.isFiltersVisible;
  },
  getActiveGridLevel: state => {
    return state.activeGridLevel;
  },
  getGeoLevel: state => {
    return state.gridLevels[state.activeGridLevel];
  },
};
